import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const OurClientsection = ({ data }) => {
  // const brands = useSelector((state) => state.Dashboard?.Brands) || [];

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
        mt: { xs: 4, md: 6 },
        px: 1,
        py: { xs: 3, sm: 5 },
        mb: 4,
        maskImage:
          "linear-gradient(to right, transparent, #fff 10%, #fff 90%, transparent)",
        WebkitMaskImage:
          "linear-gradient(to right, transparent, #fff 10%, #fff 90%, transparent)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "max-content",
          animation: "scrollLeft 20s linear infinite",

          "@keyframes scrollLeft": {
            "0%": {
              transform: "translateX(0)",
            },
            "100%": {
              transform: "translateX(-50%)",
            },
          },

          "&:hover": {
            animationPlayState: "paused",
          }
        }}
      >
        {data?.map((item, index) => (
          <Link
            to={`/card-details/${item?.slug ?? item?.node?.slug}`}
            key={`${item?.id || index}-${index}`}
            style={{ textDecoration: 'none' }}
          >
            <Box
              component="img"
              src={item?.productImages?.[0]?.url}
              alt="brand"
              sx={{
                width: {
                  xs: "80px",
                  sm: "140px",
                  md: "150px",
                },
                background: "transparent",


                boxShadow: '0 6px 16px rgba(0,0,0,0.12)',

                height: {
                  xs: 50,
                  sm: 80,
                  md: 90,
                },

                mx: {
                  xs: 2,
                  sm: 4,
                },

                objectFit: "cover",
                flexShrink: 0,

                borderRadius: "10px",

                transition: "transform 0.3s ease-in-out",

                "&:hover": {
                  transform: "scale(1.1)",
                },
              }}
            />
          </Link>
        ))}
      </Box>
    </Box>
  );
};

export default OurClientsection;
